import CKEditorField from "components/CkEditor/CkEditor";
import { CustomAsyncSelect } from "components/Common/Common";
import SaveRecommendationTemplatePop from "components/Modals/SaveRecommendationTemplate";
import { AppSelect2Field } from "components/shared/FormComponents/AppSelect2Field";
import CustomEditor from "components/TipTapEditor/CustomeEditor";
import { FieldArray, useFormikContext } from "formik";
import useModal from "hooks/useModal";
import { useEffect, useState } from "react";
import down_arrow_img from "../../../../Assets/images/down-arro.png"
import { useGetRecommendationTemplatesQuery, useLazyGetRecommendationTemplatesQuery } from "store/services/clients/reports-v2/recommendationTemplates";
import threDots_img from "Assets/images/three-dots.png"
import { Col, Dropdown, Row } from "react-bootstrap";

const QuestionMultipleRecommendation = ({ question, speechToText = false, fieldData, previewMode, clientType, assessmentId, maxRecommendations = 4 }) => {
    const fieldName = "recommendation";
    const [selectedTemplate, setSelectedTemplate] = useState(null);
    const { setFieldValue, values } = useFormikContext();

    // save template modal
    const { show, data, open, close } = useModal();

    const [getTemplates, { isFetching }] = useLazyGetRecommendationTemplatesQuery();

    const getTemplateOptions = async (search) => {
        try {
            const data = await getTemplates({ assessmentId, search, clientType, status: "" }).unwrap();
            const templates = data?.records || [];
            return templates?.map(i => ({ label: i.title, value: i }))
        } catch (error) {
            console.log("Error Getting template options", error);
        };
    };

    // useEffect(() => {
    //     if (!fieldData?.length) {
    //         return;
    //     }

    //     fieldData.forEach((data, index) => {
    //         setFieldValue(`${fieldName}[${index}]`, {
    //             id: data?.id,
    //             answers: data?.answers,
    //             attachmentData: data?.attachmentData ? JSON.parse(data?.attachmentData) : [],
    //         })
    //     })
    // }, [fieldData, fieldName]);

    const handleTemplateSelect = (index, selected) => {
        setSelectedTemplate(selected);
        setFieldValue(`${fieldName}[${index}]`, {
            answers: selected?.value?.answers || ""
        })
    }

    return (
        <div>
            <SaveRecommendationTemplatePop
                showPopup={show}
                closePopup={close}
                data={data}
                clientType={clientType}
                assessmentId={assessmentId}
            />


            <FieldArray name={fieldName}>
                {({ push, remove }) => (
                    <>
                        {values[fieldName]?.map((_, index) => (
                            <div key={index} className="mb-2">
                                <RecommendationForm
                                    question={question}
                                    index={index}
                                    speechToText={speechToText}
                                    setFieldValue={setFieldValue}
                                    values={values}
                                    fieldName={fieldName}
                                    getTemplateOptions={getTemplateOptions}
                                    openModal={open}
                                    remove={remove}
                                />
                            </div>
                        ))}

                        <div className="d-flex mt-2 align-items-center gap-3">
                            {maxRecommendations && values[fieldName]?.length < maxRecommendations && (
                                <button
                                    type="button"
                                    className="blue-discharge-screen-btn mt-0"
                                    onClick={() =>
                                        push({
                                            answers: "",
                                            attachmentData: [],
                                        })
                                    }
                                >
                                    Add Recommendation
                                </button>
                            )}
                            <p className="mb-0" style={{ color: "#071E3E", fontSize: "14px", fontStyle: "italic" }}>Max. {maxRecommendations} per plan.</p>
                        </div>
                    </>
                )}
            </FieldArray>
        </div>
    );
};

const RecommendationForm = ({ index, question, speechToText, setFieldValue, values, fieldName, getTemplateOptions, openModal, remove }) => {
    const [selectedTemplate, setSelectedTemplate] = useState(null);

    const handleTemplateSelect = (selected) => {
        setSelectedTemplate(selected);
        setFieldValue(`${fieldName}[${index}]`, { answers: selected?.value?.answers || "", attachmentData: values?.[fieldName]?.[index]?.attachmentData })
    }

    return (
        <>
            <Row style={{ borderBottom: "0.75px solid #000000", padding: "0 0 7px 0" }} className="align-items-center">
                <Col lg="4">
                    <p className="text-uppercase m-0 fw-sbold themeBlue" style={{ whiteSpace: "nowrap" }}>Recommendation {index + 1}</p>
                </Col>
                <Col lg="8">
                    <div className="d-flex justify-content-between gap-3 align-items-center">
                        <div className="w-100">
                            <CustomAsyncSelect
                                placeholder={"(no template selected)"}
                                loadOptions={getTemplateOptions}
                                onChange={(selected) => handleTemplateSelect(selected)}
                                value={selectedTemplate}
                                defaultOptions={true}
                            />
                        </div>
                        <div className="cstm-dropdownclass">
                            <Dropdown>
                                <Dropdown.Toggle id="dropdown-basic">
                                    <img width={19} height={18} src={threDots_img} alt="threDots_img" />
                                </Dropdown.Toggle>

                                <Dropdown.Menu>
                                    <Dropdown.Item onClick={() => remove(index)}>Delete</Dropdown.Item>
                                </Dropdown.Menu>
                            </Dropdown>
                        </div>
                    </div>
                </Col>
            </Row>
            <div className="ck-editor-wrapper mt-2" style={{ borderBottom: "0.75px solid #315D99", paddingBottom: "25px" }}>
                <Row>
                    <Col lg="4">
                        <p style={{ fontStyle: "italic" }}>{question.placeholder}</p>
                    </Col>
                    <Col lg='8'>
                        <CustomEditor speechToText={speechToText} name={`${fieldName}[${index}].answers`} attachmentName={`${fieldName}[${index}].attachmentData`} />
                        <button
                            className="blue-discharge-screen-btn mt-2"
                            type="button"
                            onClick={() => {
                                openModal({
                                    name: values[fieldName][index]?.name,
                                    answers: values[fieldName][index]?.answers,
                                });
                            }}
                        >
                            Save to Templates
                        </button>
                    </Col>
                </Row>
                {/* <CKEditorField
          key={index}
          items={[
            'bold',
            'italic',
            'underline',
            'alignment',
            '|',
            'bulletedList',
            'numberedList',
          ]}
          value={values[fieldName][index]?.answers}
          handleChange={(event, editor) => {
            setFieldValue(`${fieldName}[${index}].answers`, editor?.getData());
          }}
        /> */}
            </div>

        </>
    )
}

export default QuestionMultipleRecommendation;